import { useCallback, useState } from 'react'
import CloseGlyph from './CloseGlyph'
import { NotificationKindIcon } from './NotificationIcons'
import { useNotificationSwipe } from '../hooks/useNotificationSwipe'
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion'
import { announcement, hasNotificationCopy, notificationKind, toastDuration } from '../utils/notificationPolicy'
import './NotificationToast.css'

const NotificationToast = ({ notification, onDismiss }) => {
  const reducedMotion = usePrefersReducedMotion()
  const [swiping, setSwiping] = useState(false)
  const handleInteract = useCallback((active) => {
    setSwiping(active)
  }, [])
  const swipe = useNotificationSwipe({
    reducedMotion,
    onDismiss,
    onInteractChange: handleInteract,
  })

  if (!hasNotificationCopy(notification)) return null

  const kind = notificationKind(notification.type)
  const { role, ariaLive } = announcement(kind)
  const duration = notification.toastDuration ?? toastDuration(notification)

  return (
    <div
      ref={swipe.nodeRef}
      className={swipe.className}
      style={swipe.style}
    >
      <div
        className={`ntoast is-${kind}${swiping || swipe.dragging ? ' is-swiping' : ''}${swipe.exiting ? ' is-swipe-exit' : ''}`}
        role={role}
        aria-live={ariaLive}
        aria-atomic="true"
      >
        <span className="ntoast-icon">
          <NotificationKindIcon kind={kind} />
        </span>
        <div className="ntoast-body">
          {notification.title ? <p className="ntoast-title">{notification.title}</p> : null}
          {notification.message ? <p className="ntoast-message">{notification.message}</p> : null}
        </div>
        <button
          type="button"
          className="ntoast-close"
          aria-label="Fermer la notification"
          onClick={onDismiss}
        >
          <CloseGlyph size={16} />
        </button>
        {duration ? (
          <span
            className="ntoast-timer"
            style={{ '--ntoast-duration': `${duration}ms` }}
            onAnimationEnd={onDismiss}
            aria-hidden="true"
          />
        ) : null}
      </div>
    </div>
  )
}

export default NotificationToast
